import React from 'react'
import { Container, Row, Col } from "react-bootstrap"
import SectionHeader from '../SectionHeader'
import Para from '../Para'
import Button from '../Button'
import "./styles.scss"
import { Link } from 'react-router-dom'

export default function CTA() {
  return (
    <div className='ctawrapper'>
      <Row className=' '>
        <Col md={4}>
          <SectionHeader className="">
            <h2 className="title text-white">
              Join us & Spread  Experiences
            </h2>
          </SectionHeader>
        </Col>
        <Col md={5}>
          {/* <Para className="text-white fw-semibold">
            Borem ipsum dolor sit amet, consectetur adipiscing eliawe awUt elit ellus, luctus nec ullamcorper mattisBorem
          </Para> */}
        </Col>
        <Col md={3}>
        <Link to={"/contact-us"} style={{ textDecoration: 'none' }}>
            <Button className=" btncomponent ctabtn">
              Get in touch with us
            </Button>
          </Link> 
        {/*   <button type="button" className="btncomponent ctabtn" data-bs-toggle="modal" data-bs-target="#conatctUsModal">
            Get in touch with us
          </button> */}
        </Col>
      </Row>
    </div>
  )
}
